<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import { tick } from 'svelte';
	// Stores
	import SportEventStore from '@/Stores/Sport/SportEventStore.js';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Components
	import Datepicker from '@/Components/Datepicker.svelte';
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';

	export let event;
	export let open = false;

	let newStartTime;
	let sending = false;
	let newManualStartDate = dayjs(event.start_time).format('YYYY-MM-DD');
	let newManualStartTime = dayjs(event.start_time).format('HH:mm');

	$: newStartTime = dayjs(newManualStartDate + ' ' + newManualStartTime + ':00');

	window.scrollTo(0, 0);

	function overrideStartTime() {
		if (dayjs(newStartTime).isSame(dayjs(event.start_time))) return;
		sending = true;
		SportEventStore.updateOverrideStartTime(event.id, dayjs(newStartTime).format('YYYY-MM-DDTHH:mm:ssZ'))
			.then(() => {
				notify({
					type: 'success',
					title: event.name,
					message: 'Override Start Time',
					timeout: 3
				});
				open = false;
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to Override Start Time',
					timeout: 5
				});
			})
			.finally(() => (sending = false));
	}

	function startNow() {
		newManualStartDate = dayjs().format('YYYY-MM-DD');
		newManualStartTime = dayjs().format('HH:mm');
		tick().then(() => overrideStartTime());
	}

	function resetEventTime() {
		newManualStartDate = dayjs(event.start_time).format('YYYY-MM-DD');
		newManualStartTime = dayjs(event.start_time).format('HH:mm');
	}

	function addMinutes(minutes) {
		newManualStartTime = dayjs(newManualStartDate + ' ' + newManualStartTime + ':00')
			.add(minutes, 'minute')
			.format('HH:mm');
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Override Start Time</h2>
		<div class="pt-1 text-center">{event.name}</div>
		<div class="flex justify-center py-2 space-x-4">
			<p>
				Scheduled Start Time: {dayjs(event.start_time).format('D MMM YYYY, HH:mm')}
			</p>
		</div>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<div class="flex justify-center mb-4 space-x-4">
				<button
					class="btn border-4 border-danger hover:bg-danger hover:text-white text-danger font-extrabold"
					on:click={() => startNow()}
				>
					Start Now
				</button>
				<button class="btn btn-danger" on:click={() => addMinutes(-1)}> -1 min</button>
				<button class="btn btn-primary" on:click={() => addMinutes(1)}> +1 min</button>
				<button class="btn btn-primary" on:click={() => addMinutes(5)}> +5 min</button>
				<button class="btn btn-primary" on:click={() => addMinutes(10)}> +10 min</button>
				<button class="btn btn-primary" on:click={() => addMinutes(15)}> +15 min</button>
				<button class="btn btn-muted" on:click={() => resetEventTime()}> Reset</button>
			</div>
			<div class="mb-4 font-semibold">
				New Start Time:
				<Datepicker
					selected={newManualStartDate}
					height="32px"
					displayFormat="DD-MM-YYYY"
					dateChosen={(date) => {
						newManualStartDate = dayjs(date).format('YYYY-MM-DD');
					}}
					btnStyle="px-2 py-1 border-2 focus:outline-none hover:text-dark-grey"
				/>
				<input type="time" class="border-2" style="height:32px;" bind:value={newManualStartTime} />
			</div>
			<LoadingButton on:click={overrideStartTime} loading={sending} className="mb-4 btn btn-primary-action"
				>Update
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click|preventDefault={() => (open = false)}> Cancel</button>
		</div>
	</Modal>
{/if}
